export function parseMachineMaintenanceDeepLink(search) {
  const params = new URLSearchParams(search || '');
  const machineIdRaw = params.get('machineId');
  const maintenanceIdRaw = params.get('maintenanceId');
  const workOrderNumber = (params.get('workOrderNumber') || '').trim();
  const machineId = machineIdRaw ? Number(machineIdRaw) : null;
  const maintenanceId = maintenanceIdRaw ? Number(maintenanceIdRaw) : null;

  if (!(Number.isFinite(machineId) && machineId > 0)) {
    return null;
  }

  return {
    machineId,
    maintenanceId: Number.isFinite(maintenanceId) && maintenanceId > 0 ? maintenanceId : null,
    workOrderNumber: workOrderNumber || null,
  };
}
